// Site analytics (self-hosted Umami, see deploy/analytics/README.md). The server adds the
// tracker to every page only when analytics is configured, so in local dev, tests and the
// e2e stack `window.umami` is absent and every call here is a no-op.
/** Every custom event the app sends. Keep deploy/analytics/README.md in step. */ export const AnalyticsEvent = {
    ctaRequestAccess: 'cta-request-access',
    ctaBookCall: 'cta-book-call',
    /** A link into an audience page (For dealers / Import my own); location says which. */ ctaAudience: 'cta-audience',
    requestAccessSubmitted: 'request-access-submitted',
    requestAccessFailed: 'request-access-failed',
    signedIn: 'signed-in',
    signedUp: 'signed-up',
    emailVerified: 'email-verified',
    /** A CTA into sign-up; location says which. */ ctaSignup: 'cta-signup',
    /** A dealer website theme preview opened on /dealer-websites; theme says which. */ sitePreviewOpened: 'site-preview-opened',
    inviteAccepted: 'invite-accepted',
    huntCreated: 'hunt-created',
    lotTracked: 'lot-tracked',
    carAdded: 'car-added',
    carSold: 'car-sold'
};
function umami() {
    return typeof window === 'undefined' ? undefined : window.umami;
}
/** Records a custom event. Never throws: analytics must not break the page. */ export function track(name, data) {
    try {
        umami()?.track(name, data);
    } catch  {
    // Tracker failed or was blocked; nothing to do.
    }
}
/**
 * Tags this browser session with the shop (its public id, plan and role), so a shop can be
 * followed from first visit to active use. Never a person's name or email.
 */ export function identifyShop(orgId, data) {
    const props = {};
    if (data.plan) props.plan = data.plan;
    if (data.role) props.role = data.role;
    try {
        umami()?.identify(orgId, props);
    } catch  {
    // As above.
    }
}
/**
 * Props for a link Umami tracks on click (`data-umami-event`), no handler needed:
 * `<ButtonLink {...ctaEvent(AnalyticsEvent.ctaRequestAccess, 'hero')} />`.
 */ export function ctaEvent(name, location, audience) {
    return {
        'data-umami-event': name,
        'data-umami-event-location': location,
        ...audience ? {
            'data-umami-event-audience': audience
        } : {}
    };
}
